export interface IElement {
  elementId: number;
  elementDesc: string;
  elementCode: string;
}
